var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { fetchSummary } from '../services/conflictResolutionService';
export const useConflictResolution = (inspectionId, enabled) => {
    const [summary, setSummary] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        if (!enabled) {
            setSummary(null);
            setHasError(false);
            setIsLoading(false);
            return undefined;
        }
        let isCurrent = true;
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            setHasError(false);
            try {
                const result = yield fetchSummary(inspectionId);
                if (isCurrent)
                    setSummary(result);
            }
            catch (_a) {
                if (isCurrent)
                    setHasError(true);
            }
            finally {
                if (isCurrent)
                    setIsLoading(false);
            }
        });
        void load();
        return () => {
            isCurrent = false;
        };
    }, [enabled, inspectionId]);
    return { summary, isLoading, hasError };
};
